<script lang="ts" setup>
const isExporting = ref(false);
const documentId = inject("documentId") as any;
const exportToWord = async () => {
  isExporting.value = true;
  await useExportLoadedDocument(documentId);
  isExporting.value = false;
};

const props = defineProps({
  variant: {
    type: String as PropType<"outlined" | "text">,
    default: "text",
  },
  color: {
    type: String,
    default: "primary",
  },
});
</script>

<template>
  <BaseOutlinedButton
    v-if="variant === 'outlined'"
    :color="color"
    @click.stop.prevent="exportToWord"
    :show-spinner="isExporting"
  >
    <div class="flex flex-row items-center justify-start w-full">
      <icon name="file-icons:microsoft-word" class="mr-2" />
      <span class="block"> Export to Word </span>
    </div>
  </BaseOutlinedButton>
  <BaseTextButton
    v-else
    :color="color"
    @click.stop.prevent="exportToWord"
    :show-spinner="isExporting"
  >
    <div class="flex flex-row items-center justify-start w-full">
      <icon name="file-icons:microsoft-word" class="mr-2" />
      <span class="block"> Export to Word </span>
    </div>
  </BaseTextButton>
</template>

<style scoped></style>
